module.exports = __webpack_public_path__ + "img/icon-1.54ee5538.png";